import { all, fork } from "redux-saga/effects";

import { Authnz } from "../components";
import searchForClaimWatcher from "./appSagas/claims/search";
import drugSearchWatcher from "./appSagas/drug/search";
import drugSelectedSearchWatcher from "./appSagas/drug/searchForSelected";
import getGroupWatcher from "./appSagas/groups/get";
import getMemberWatcher from "./appSagas/members/get";
import searchForMemberWatcher from "./appSagas/members/search";
import migrateUserWatcher from "./appSagas/migrate/migrate";
import getPharmacyWatcher from "./appSagas/pharmacy/get";
import searchForPharmacyWatcher from "./appSagas/pharmacy/search";
import getPlanAccountGetWatcher from "./appSagas/planAccounts/get";
import searchForPlanBenefitWatcher from "./appSagas/planBenefits/search";
import getPlanWatcher from "./appSagas/plans/get";
import searchForPlanWatcher from "./appSagas/plans/search";
import createPricingLevelWatcher from "./appSagas/pricingLevels/create";
import getPricingLevelWatcher from "./appSagas/pricingLevels/get";
import listPricingLevelsWatcher from "./appSagas/pricingLevels/list";
import updatePricingLevelWatcher from "./appSagas/pricingLevels/update";
import getProductListWatcher from "./appSagas/productLists/list";
import downloadBatchManualClaimWatcher from "./appSagas/transmissions/batchManual/download";
import getBatchManualClaimWatcher from "./appSagas/transmissions/batchManual/get";
import getBatchManualClaimListWatcher from "./appSagas/transmissions/batchManual/list";
import uploadManualClaimBatchWatcher from "./appSagas/transmissions/batchManual/upload";
import downloadBatchTestClaimWatcher from "./appSagas/transmissions/batchTest/download";
import getBatchTestClaimWatcher from "./appSagas/transmissions/batchTest/get";
import getBatchTestClaimListWatcher from "./appSagas/transmissions/batchTest/list";
import uploadTestClaimBatchWatcher from "./appSagas/transmissions/batchTest/upload";
import transmissionManualWatcher from "./appSagas/transmissions/manualTransmission";
import transmissionTestAsBatchWatcher from "./appSagas/transmissions/testAsBatchTransmission";
import transmissionTestWatcher from "./appSagas/transmissions/testTransmission";

export default function* rootSagas(): Generator {
  yield all([
    fork(Authnz.authnzWatcher),
    fork(searchForMemberWatcher),
    fork(searchForClaimWatcher),
    fork(searchForPlanBenefitWatcher),
    fork(getMemberWatcher),
    fork(searchForPlanWatcher),
    fork(getPlanWatcher),
    fork(getPlanAccountGetWatcher),
    fork(getGroupWatcher),
    fork(searchForPharmacyWatcher),
    fork(getPharmacyWatcher),
    fork(getBatchTestClaimWatcher),
    fork(downloadBatchTestClaimWatcher),
    fork(getBatchTestClaimListWatcher),
    fork(getBatchManualClaimWatcher),
    fork(downloadBatchManualClaimWatcher),
    fork(getBatchManualClaimListWatcher),
    fork(transmissionTestWatcher),
    fork(transmissionTestAsBatchWatcher),
    fork(transmissionManualWatcher),
    fork(uploadTestClaimBatchWatcher),
    fork(uploadManualClaimBatchWatcher),
    fork(drugSearchWatcher),
    fork(drugSelectedSearchWatcher),
    fork(getProductListWatcher),
    fork(migrateUserWatcher),
    fork(listPricingLevelsWatcher),
    fork(createPricingLevelWatcher),
    fork(getPricingLevelWatcher),
    fork(updatePricingLevelWatcher),
  ]);
}
